// Include Lightbox 
import PhotoSwipeLightbox from 'photoswipe/lightbox';

import "../sass/style.scss";

const lightbox = new PhotoSwipeLightbox({
    // may select multiple "galleries"
    gallery: '.gallery',

    // Elements within gallery (slides)
    children: 'a.lightbox-link',

    // setup PhotoSwipe Core dynamic import
    pswpModule: () => import('photoswipe')
});




// use <video> instead of <img> when supplied
lightbox.on('contentLoad', (e) => {
    const { content, isLazy } = e;
    if (content.data.src.split('.').pop() == "mp4") {
        // prevent to stop the default behavior
        e.preventDefault();

        content.element = document.createElement('video');


        content.element.src = content.data.src;
        content.element.setAttribute('alt', '');
        content.element.className = 'pswp__img';
        content.element.setAttribute("loop", "")
        content.element.setAttribute("muted", "")
        content.element.setAttribute("playsinline", "")
        content.element.setAttribute("autoplay", "")



        content.state = 'loading';

        if (content.element.canplay) {
            content.onLoaded();
        } else {
            content.element.oncanplay = () => {
                content.onLoaded();
            };

            content.element.onerror = () => {
                content.onError();
            };
        }
    }
});


// by default PhotoSwipe appends <img>,
// but we want to append <video>
lightbox.on('contentAppend', (e) => {
    const { content } = e;
    if (content.element && !content.element.parentNode) {
        e.preventDefault();
        content.slide.container.appendChild(content.element);
    }
});

// for next/prev navigation with <video>
// by default PhotoSwipe removes <img>,
// but we want to remove <video>
lightbox.on('contentRemove', (e) => {
    const { content } = e;
    if (content.element && content.element.parentNode) {
        e.preventDefault();
        content.element.remove();
    }
});

lightbox.addFilter('thumbEl', (thumbEl, data, index) => {
    const { element } = data;
    const el = element.querySelector("video");
    if (el) {
        return el;
    }

    return thumbEl;
});

// Download Button

lightbox.on('uiRegister', function () {
    lightbox.pswp.ui.registerElement({
        name: 'download-button',
        order: 8,
        isButton: true,
        tagName: 'a',

        // SVG with outline
        html: {
            isCustomSVG: true,
            inner: '<path d="M20.5 14.3 17.1 18V10h-2.2v7.9l-3.4-3.6L10 16l6 6.1 6-6.1ZM23 23H9v2h14Z" id="pswp__icn-download"/>',
            outlineID: 'pswp__icn-download'
        },

        // Or provide full svg:
        // html: '<svg width="32" height="32" viewBox="0 0 32 32" aria-hidden="true" class="pswp__icn"><path d="M20.5 14.3 17.1 18V10h-2.2v7.9l-3.4-3.6L10 16l6 6.1 6-6.1ZM23 23H9v2h14Z" /></svg>',

        // Or provide any other markup:
        // html: '<i class="fa-solid fa-download"></i>' 

        onInit: (el, pswp) => {
            el.setAttribute('download', '');
            el.setAttribute('target', '_blank');
            el.setAttribute('rel', 'noopener');

            pswp.on('change', () => {
                el.href = pswp.currSlide.data.src;
            });
        }
    });
});

// Add share button 
lightbox.on('uiRegister', function () {
    if (navigator.share) {
        lightbox.pswp.ui.registerElement({
            name: 'share-button',
            className: 'pswp__button--share-button icon-share',
            ariaLabel: 'Share',
            order: 7,
            isButton: true,
            //html: 'Test',
            onClick: (event, el) => {
                share(pswp.currSlide.data.src)
            }
        });
    }

    if(typeof variable !== 'undefined' && can_delete_image){
        lightbox.pswp.ui.registerElement({
            name: 'delete-button',
            className: 'pswp__button--share-button icon-trash',
            ariaLabel: 'Delete',
            order: 7,
            isButton: true,
            //html: 'Test',
            onClick: (event, el) => {
                const url = new URL(lightbox.pswp.currSlide.data.src);
                console.log(lightbox.pswp.currSlide.data.src);

                if (confirm("Das Bild " + url.pathname.split("/").slice(-1)[0] +" wirklich löschen?")) {
                    jQuery.post('/wp-admin/admin-ajax.php', {
                            action: "delete_image",
                            name: url.pathname.split("/").slice(-1)[0],
                            dir: url.pathname.split("/").slice(-2)[0],
                            event: event_id,
                        },
                        function(response) {
                            location.reload()
                        });
                }
            }
     
        });
    }
});
lightbox.init();








import { observeElementInViewport } from 'observe-element-in-viewport'



var grid = jQuery('.masonry-grid').ready().masonry({
    // options
    itemSelector: '.masonry-grid-item',
    //horizontalOrder: true,
    percentPosition: true,
    columnWidth: '.grid-sizer',
    gutter: '.gutter-sizer',
});
jQuery('.masonry-grid-item').ready().animate({
    opacity: 1
}, 500)


init_share()



// Init for single image view
function init_share() {
    jQuery(document).ready(function () {
        if (navigator.share) {
            jQuery(".share-container").css("display", "block")
            jQuery(".share").click(function () {
                share(jQuery(this).data("share-link"))
            })
        }
    })
}

function share(url) {
    if (navigator.share) {
        fetch(url)
            .then(res => res.blob()) // Gets the response and returns it as a blob
            .then(blob => {
                var file = new File([blob], url.substring(url.lastIndexOf('/') + 1), {
                    type: 'image/jpeg'
                });
                var toShare = {
                    //title: 'PHOTO-BUZZ',
                    // TODO wieder aktivieren                    <?php if (!is_fcb()) : ?>
                    //text: '<?= __("Schau dir die Fotos 📷 unserer Feier an 😊 ", "textdomain") ?>'+window.location.href,
                    //    <?php endif; ?>
                    //url: window.location.href,
                    files: [file]
                };
                if (navigator.canShare && navigator.canShare(toShare)) {
                    navigator.share(toShare);
                } else {

                    navigator.share({
                        title: 'PHOTO-BUZZ',
                        // TODO wieder aktivieren                        <?php if (!is_fcb()) : ?>
                        text: '<?= __("Schau dir das Foto 📷 unserer Feier an 😊 ", "textdomain") ?>',
                        //                       <?php endif; ?>
                        url: url,
                    });
                }

            });
    } else {
        var anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = '_blank';
        anchor.download = '';
        anchor.click();
    }

    return false;
}



function loadMore() {
    jQuery("#moreButton").off('click')
    jQuery("#moreButton").addClass('disabled')
    jQuery.getJSON(jQuery(location).attr('pathname') + "?json=1&num=100&start=" + jQuery(".pswp-thumb a").last().data("date"), null, function (data) {
        console.log(data)
        var hours = Object.values(data.data);
        if (data.data.length == 0) jQuery("#moreButton").addClass("hide");
        for (var i = 0; i < hours.length; ++i) {

            if (!jQuery("#" + hours[i].date + " .img-container").length) {
                jQuery("#event-container").append(hours[i].markup);
                jQuery('#' + hours[i].date + ' .masonry-grid').masonry({
                    // options
                    itemSelector: '.masonry-grid-item',
                    //horizontalOrder: true,
                    percentPosition: true,
                    columnWidth: '.grid-sizer',
                    gutter: '.gutter-sizer',
                });
            }

            for (var j = 0; j < hours[i].data.length; j++) {
                var newelem = hours[i].data[j].markup;

                newelem = jQuery(newelem);
                jQuery("#" + hours[i].date + " .gallery-grid").append(newelem).masonry("appended", newelem);
                newelem.find("video").each(function () {
                    observe_video(this)
                })
            }
            jQuery("#" + hours[i].date + " .gallery-grid").masonry();
        }


        jQuery("#moreButton").click(loadMore);
        jQuery("#moreButton").removeClass('disabled');
    });



}
jQuery("#moreButton").click(loadMore);

jQuery(window).scroll(function () {
    /*if (typeof Foundation!== undefined && Foundation.MediaQuery.atLeast('medium')) var offset = 700;
    else*/ var offset = 1400;
    if (jQuery(window).scrollTop() + offset >= jQuery(document).height() - jQuery(window).height()) {
        jQuery("#moreButton").click();
    }
});

var unobserve = []

function observe_video(vid) {
    // to use window as viewport, pass this option as null
    const viewport = null
    // handler for when target is in viewport
    const inHandler = (entry, unobserve, targetEl) => targetEl.play()
    // handler for when target is NOT in viewport
    const outHandler = (entry, unobserve, targetEl) => targetEl.pause()
    // the returned function, when called, stops tracking the target element in the
    // given viewport 
    unobserve.push(observeElementInViewport(vid, inHandler, outHandler, {
        // set viewport
        viewport,
        // decrease viewport top by 100px
        // similar to this, modRight, modBottom and modLeft exist
        modTop: '0px',
        // threshold tells us when to trigger the handlers.
        // a threshold of 90 means, trigger the inHandler when atleast 90%
        // of target is visible. It triggers the outHandler when the amount of
        // visible portion of the target falls below 90%.
        // If this array has more than one value, the lowest threshold is what
        // marks the target as having left the viewport
        threshold: [50]
    }))

}

jQuery(document).ready(function () {
    jQuery('video').each(function (index) {
        observe_video(this)
    })
});